class BrushSprayPaint {
  constructor() {
    this.canvas = document.createElement('canvas');
    this.sprayContext = this.canvas.getContext('2d');
    this.ready = false;
    this.rotation = 0;
    this.flow = 1;
    this.capSize = 1;

    this.img = new Image();
    this.img.addEventListener('load', () => {
      this.canvas.width = this.img.width / 2;
      this.canvas.height = this.img.height / 2;
    });
    this.img.src = require('url:../src/assets/images/spray.png');
  }

  drawSprayMask(color) {
    this.sprayContext.globalCompositeOperation = 'source-over';
    this.sprayContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.sprayContext.save();
    this.sprayContext.translate(this.canvas.width / 2, this.canvas.height / 2);
    this.sprayContext.rotate(this.rotation);
    this.sprayContext.translate(
      -this.canvas.width / 2,
      -this.canvas.height / 2
    );
    this.sprayContext.drawImage(
      this.img,
      0,
      0,
      this.img.width,
      this.img.height,
      0,
      0,
      this.canvas.width,
      this.canvas.height
    );
    this.sprayContext.restore();
    this.sprayContext.globalCompositeOperation = 'source-in';
    this.sprayContext.fillStyle = color;
    this.sprayContext.fillRect(0, 0, this.canvas.width, this.canvas.height);
  }

  drawCircle(ctx, x, y) {
    ctx.fillStyle = 'rgba(0,0,0,0.4)';
    ctx.globalAlpha = this.flow;
    ctx.beginPath();
    ctx.drawImage(
      this.canvas,
      0,
      0,
      this.canvas.width,
      this.canvas.height,
      x - (this.canvas.width * this.capSize) / 2,
      y - (this.canvas.height * this.capSize) / 2,
      this.canvas.width * this.capSize,
      this.canvas.height * this.capSize
    );
    ctx.fill();
  }

  update() {
    this.rotation += 0.02 * (Math.PI / 180);
    if (Math.random() < 0.3) {
      this.rotation = Math.random() * Math.PI * 2;
    }
  }

  draw(ctx, x, y, color, radius) {
    this.capSize = radius / this.canvas.width;
    this.drawSprayMask(color);
    this.drawCircle(ctx, x, y);
  }
}
export { BrushSprayPaint };
